// ./src/components/layouts/DashboardLayout/PWAUpdateBanner.tsx

import React from "react";
import { Paper, Group, Box, Text, Button, CloseButton, useMantineTheme } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { useAppUpdate } from "@/contexts/PWAContext";

import { AppIcon } from "@/components/generic/AppIcon";

export const PWAUpdateBanner: React.FC = () => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const { available, apply, dismiss } = useAppUpdate();

  if (!available) {
    return null;
  }

  return (
    <Paper
      p="sm"
      radius={0}
      bg="brand.0"
      style={{
        borderBottom: `1px solid ${theme.colors.brand[2]}`,
      }}
    >
      <Group justify="space-between" wrap="nowrap" gap="sm">
        <Group gap="sm" wrap="nowrap">
          <Box
            w={32}
            h={32}
            bg="brand.1"
            style={{
              borderRadius: theme.radius.md,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <AppIcon iconName="Download" size={18} color={theme.colors.brand[6]} />
          </Box>
          <Box>
            <Text size="sm" fw={600} c="brand.8">
              {t("pwa.updateAvailable", "Update available")}
            </Text>
            <Text size="xs" c="brand.6">
              {t("pwa.updateDescription", "A new version is ready to install")}
            </Text>
          </Box>
        </Group>
        <Group gap="xs" wrap="nowrap">
          <Button size="xs" variant="filled" color="brand" onClick={apply}>
            {t("pwa.update", "Update")}
          </Button>
          <CloseButton size="sm" onClick={dismiss} />
        </Group>
      </Group>
    </Paper>
  );
};